jQuery.fn.selectText = function(){
   var doc = document;
   var element = this[0];
   var range, selection;
   // console.log(this, element);
   if (doc.body.createTextRange) {
        range = document.body.createTextRange();
        range.moveToElementText(element);
        range.select();
   } else if (window.getSelection) {
        selection = window.getSelection();      
        range = document.createRange();
        range.selectNodeContents(element);
        selection.removeAllRanges();
        selection.addRange(range);
   }
};

// modal functions
// include the close modal functions
function closeModal() {
    $('.overlay, .modal').removeClass('visible');
}

function openModal(modal) {
    
    var scrollTop = $(window).scrollTop();
    $(modal).css({
        'top': (scrollTop-500)+'px'
    });
    
    setTimeout(function() {
        $(modal).addClass('visible');
        $(modal).find('.fields li input, .fields li textarea').each(function() {
            var $this = $(this);
            if($this.val() !== '') {
                $this.parent('li').addClass('filled');
            } else {
                $this.parent('li').removeClass('filled');
            }
        });
    }, 100);

    $('.overlay').addClass('visible');
}

$('body').click(function(e){
    if($(e.target).attr('class') === 'overlay visible') {
        closeModal();
    }
});

$(document).keyup(function(e) {
    if (e.keyCode === 27) { // Esc
        closeModal();
    }
});


$('body').on('click', '.modal a.close', function() {
    closeModal();        
    return false;
});

$('body').on('click', '.ignore', function() {
    return false;
});


function loading(text = 'Loading...') {
    $('.loading-overlay, .loading').addClass('visible');
    $('.loading span').html(text);
}

function unloading() {
    $('.loading-overlay, .loading').removeClass('visible');
}

$('body').on('click', '.copy-text', function() {
    var $this = $(this);
    var text = $this.text();
    var target = $('.copy-target[data-target="'+$this.attr('data-target')+'"]');
    target.selectText();
    document.execCommand("Copy", false, null);
    window.getSelection().removeAllRanges();
    $this.text($this.attr('data-text'));
    setTimeout(function() {
        $this.text(text);
    }, 2000);
    return false;
});

$('body').on('click', '.copy-target', function() {
    $(this).selectText();
    return false;
});